export { SchoolAssessmentDetailModal } from "./SchoolAssessmentDetailModal"
export type { SchoolAssessmentDetailModalProps } from "./SchoolAssessmentDetailModal"
